var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColaboratorsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 4.77334C11.9602 4.76667 11.9135 4.76667 11.8735 4.77334C10.9535 4.74 10.2202 3.98667 10.2202 3.05334C10.2202 2.1 10.9869 1.33333 11.9402 1.33333C12.8935 1.33333 13.6602 2.10667 13.6602 3.05334C13.6535 3.98667 12.9202 4.74 12.0002 4.77334Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3135 9.62667C12.2268 9.78001 13.2335 9.62001 13.9401 9.14667C14.8801 8.52001 14.8801 7.49334 13.9401 6.86667C13.2268 6.39334 12.2068 6.23334 11.2935 6.39334",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97983 4.77334C4.01983 4.76667 4.06649 4.76667 4.10649 4.77334C5.02649 4.74 5.75982 3.98667 5.75982 3.05334C5.75982 2.1 4.99316 1.33333 4.03983 1.33333C3.08649 1.33333 2.31982 2.10667 2.31982 3.05334C2.32649 3.98667 3.05983 4.74 3.97983 4.77334Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66663 9.62667C3.75329 9.78001 2.74663 9.62001 2.03996 9.14667C1.09996 8.52001 1.09996 7.49334 2.03996 6.86667C2.75329 6.39334 3.77329 6.23334 4.68663 6.39334",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00021 9.75334C7.96021 9.74667 7.91355 9.74667 7.87355 9.75334C6.95355 9.72 6.22021 8.96667 6.22021 8.03333C6.22021 7.08 6.98688 6.31333 7.94021 6.31333C8.89355 6.31333 9.66021 7.08667 9.66021 8.03333C9.65355 8.96667 8.92021 9.72667 8.00021 9.75334Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05998 11.8533C5.11998 12.48 5.11998 13.5067 6.05998 14.1333C7.12665 14.8467 8.87331 14.8467 9.93998 14.1333C10.88 13.5067 10.88 12.48 9.93998 11.8533C8.87998 11.1467 7.12665 11.1467 6.05998 11.8533Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColaboratorsIcon);
export default __webpack_public_path__ + "static/media/colaborators-icon.0b0a46ca8ae676a61cbb8d7d911fcde2.svg";
export { ForwardRef as ReactComponent };